module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/rejected-c00238c4ee655c35220bdba6d8a46fad.png";